<ng-container *transloco="let t">
  <div class="position-relative">
    <div class="date-picker w-100">
      <div class="input-group w-0 h-0">
        <input
          name="dateRangePicker"
          ngbDatepicker
          #dateRangePicker="ngbDatepicker"
          [autoClose]="'outside'"
          (dateSelect)="onDateSelection($event)"
          [displayMonths]="2"
          [dayTemplate]="dayTemplate"
          [footerTemplate]="footerTemplate"
          outsideDays="hidden"
          [startDate]="filterForm.get('dateStart')?.value"
          tabindex="-1"
          class="border-0 h-0 date-picker-input"
        />

        <ng-template #dayTemplate let-date let-focused="focused">
          <span
            class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date)"
            [class.start]="isStart(date)"
            [class.end]="isEnd(date)"
            [class.faded]="isHovered(date) || isInside(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null"
          >
            {{ date.day }}
          </span>
        </ng-template>

        <ng-template #footerTemplate>
          <div *ngIf="quickRanges.size > 0" class="p-2 border-top d-flex flex-wrap gap-2">
            <button
              *ngFor="let option of quickRanges | keyvalue"
              type="button"
              class="btn btn-sm btn-outline-primary"
              (click)="applyQuickRange(option.key)"
            >
              {{ option.value.label }}
            </button>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="input-group" [class.active]="isSelected" [class.opened]="dateRangePicker.isOpen()">
      <i class="material-symbols-rounded prepend-icon" (click)="dateRangePicker.toggle()">calendar_month</i>
      <input
        name="dateRange"
        class="form-control form-control-rounded form-control-prepend form-control-append black-placeholder fw-medium"
        [value]="dateRangeLabel"
        [placeholder]="t('shared/dateRangeFilter')"
        (click)="dateRangePicker.toggle()"
        readonly
      />
      <i *ngIf="isSelected" class="material-symbols-rounded fs-18 text-black-100 append-icon" role="button" (click)="onClearDate()">
        close
      </i>
    </div>
  </div>
</ng-container>
